import axios from 'axios';

export const clientGranel = axios.create({
  baseURL:
    process.env.REACT_APP_API_GRANEL_URL,
});

export const clientImo = axios.create({
  baseURL:
    process.env.REACT_APP_API_IMO_URL,
});

export const clientImoWithoutAuth = axios.create({
  baseURL:
    process.env.REACT_APP_API_IMO_URL,
});

export const clientCpp = axios.create({
  baseURL:
    process.env.REACT_APP_API_CPP_URL,
});

export const clientCppWithoutAuth = axios.create({
  baseURL:
    process.env.REACT_APP_API_CPP_URL,
});

export default axios.create();
